import { initialShipmentEvent, translationkeyToTextValueMapper } from "../../shared/constants";
import { ShipmentEvent, SupplyChainTrackingEvent } from "../../shared/interfaces";
import { formatEventAddress } from "../formatEventAddress";

export const transformSupplyChainTrackingEventToShipmentEvent = ({ eventCode, eventAddress, eventDescription, eventShortDescription, eventTime } : SupplyChainTrackingEvent, index : number) => {
    const shipmentEvent: ShipmentEvent = Object.assign({}, initialShipmentEvent);
    shipmentEvent.eventId = index.toString();
    shipmentEvent.eventTime = Date.parse(eventTime);
    shipmentEvent.eventStatus = eventCode;
    shipmentEvent.eventDescription = eventDescription.rttvEventDescriptionTranslatorKey;
    shipmentEvent.eventAddress = eventAddress ? formatEventAddress(eventAddress) : "";
    shipmentEvent.eventShortDescription = eventShortDescription ? `${eventShortDescription.slice(0, 1).toUpperCase()}${eventShortDescription.slice(1).toLowerCase()}`.replaceAll("_", " ") : "";
    return shipmentEvent;
};